import { fetch } from 'utils/api';

export const getTimezones = () => {
  return fetch({
    url: '/timezones',
    method: 'GET'
  });
};
